import { api } from '@/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { CACHE_KEY_USE_FETCH_USER } from './useFetchUser'

export const useCompleteSignUp = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (refCode?: string) => api.post(`/user/sign-up/complete`, refCode ? { alias: refCode } : undefined),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: [CACHE_KEY_USE_FETCH_USER] })
    },
    onError: (error) => {
      console.error(error)
    }
  })
}
